import { useCurrentStateAndParams } from "@uirouter/react";

import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

export const useIsTerritoryEligible = (): boolean => {
    const { state } = useCurrentStateAndParams();

    return siNavigator.isAdvancedSearchPage(state);
};
